<!-- eslint-disable @nx/workspace-ebiz-no-inner-html -->
<div
    class="svg-content"
    id="svgContent"
    [innerHTML]="svg() | safeContent: 'html'"
    [style.height]="heightInternal()"
    [style.width]="widthInternal()"
></div>
<!-- eslint-enable @nx/workspace-ebiz-no-inner-html -->
